export const WORKFLOW_SCROLL_CONTAINER =
  'owc-card.sc-owc-workflow-overlay > .owc-card__content-wrapper';
